module.exports = __webpack_public_path__ + "img/icon_83.c579b9f5.png";